<template>
  <div>
    <div
      v-if="loading"
      id="carregaDados"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      id="errorTicketMedioSupervisorTime"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <canvas
      id="myChart15"
      width="70"
      height="40"
    />
    <div
      v-if="exibirLegenda"
      id="legendaTicketMedioSupervisor"
      class="text-center px-3"
    >
      <div v-if="text">
        <h3>{{ text }}</h3>
      </div>
      <div v-else>
        <v-row>
          <div
            v-for="legenda in legenda"
            :key="legenda.text"
          >
            <v-avatar
              class="mr-1"
              :color="legenda.cor"
              size="12"
            />
            <span class="mr-3 font-weight-light">{{ legenda.text }}</span>
          </div>
        </v-row>
      </div><br><br>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Time from '../../../../services/time4'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashoboardTicketMedioSupervisor',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      segmento: [],
      rede: [],
      categoria: [],
      promotor: [],
      area: [],
      classificacao: [],
      linhaProducao: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      legenda: [],
      text: null,
      montarGrafico: true,
      loading: false,
      error: null,
      exibirLegenda: false,
    }),

    created () {
      eventEmit.$on('update-ticket', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-ticket', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor
        this.area = area
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true
        this.exibirLegenda = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Time.showTicketMedioTime4(this.primeiroDia, this.dataFinal, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.segmento, this.rede, this.categoria, this.promotor, this.area, this.classificacao, this.linhaProducao).then(resposta => {
          if (resposta.data.status) {
            const setPerson = new Set()

            this.legenda = resposta.data.legenda.filter((person) => {
              const duplicatedPerson = setPerson.has(person.text)
              setPerson.add(person.text)
              return !duplicatedPerson
            })

            var mobile = !(window.innerWidth < 600)

            const ctx = document.getElementById('myChart15').getContext('2d')

            this.myChart = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: resposta.data.supervisor,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    backgroundColor: resposta.data.colors,
                    order: 2,
                  },
                  {
                    label: 'Meta',
                    data: resposta.data.mediaSupervisor,
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                    type: 'line',
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: false,
                    align: 'start',
                    color: function (context) {
                      if (context.dataset.label === 'Faturamento') {
                        return '#000000'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 0) {
                        return [
                          'Faturamento: ' + resposta.data.faturamentoTotal[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                          'Fat. / Qnt. Notas: ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                          'Número de Notas: ' + resposta.data.notas[tooltipItem.index]]
                      } else if (tooltipItem.datasetIndex === 1) {
                        return 'Média: ' + resposta.data.mediaSupervisor[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado.') {
            this.text = resposta.data.msg

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
  #legendaTicketMedioSupervisor
    margin: 1rem 0 0 14rem

</style>

<style scoped>
 .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #myChart15 {
      margin: 0 0 3rem 1rem;
      width: 330px !important;
      height: 260px !important;
    }

    #legendaTicketMedioSupervisor {
      font-size: 10px;
      margin: 1rem 0 0 10rem
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart15 {
      margin: -3rem 0 0 0;
      width: 800px !important;
      height: 500px !important;
    }

    #legendaTicketMedioSupervisor {
      font-size: 14px;
      margin: 1rem 0 0 20rem
    }
  }
</style>
